import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const CartHeader = () => {
  return <>
    <Row>
      <Col md={2}></Col>
      <Col md={3}><FormattedMessage id="ml_114612" defaultMessage="X - Product Details"/></Col>
      <Col md={2}><FormattedMessage id="ml_114613" defaultMessage="X - GAS PRICES(EXCL VAT)"/></Col>
      <Col md={2}><FormattedMessage id="ml_114614" defaultMessage="X - Quantity"/></Col>
      <Col md={2}><FormattedMessage id="ml_114615" defaultMessage="X - TOTAL(EXCL VAT)"/></Col>
      <Col md={1}></Col>
    </Row>
    <Row className="ps-0 pe-0 mt-2">
      <Col className="ps-0 pe-0"><div className="line-style-1"></div></Col>
    </Row>
  </>;
};
export default CartHeader;